import { render, staticRenderFns } from "./UcContactList.yaml?vue&type=template&id=0586cf44&component"
import script from "./UcContactList.yaml?vue&type=script&lang=ts&component"
export * from "./UcContactList.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports